var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Report by Terms")]),(_vm.status)?_c('Bar',{ref:"chart",attrs:{"data":_vm.chartData,"options":_vm.options}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }